import IncidentEntryPage from "./IncidentEntryPage";

const module = {
  routeProps: {
    path: "IncidentEntry",
    component: IncidentEntryPage,
  },

  name: " Incident Entry",
  label: "Incident Entry",
  title: "Incident Entry",
  showOnMenu: true,
};

export default module;
